export default __webpack_public_path__ + "static/media/ap.53bbccc2.png";